import { c as _c } from "react/compiler-runtime";
import { formatCurrency, getPlaneImage } from "@/libs/utils";
import { StyledHotelWithPriceAndTermSlide, PlaneDiv, DestinationRowDestination, DestinationRowPrice, StyledRow, StyledH1, StyledH2 } from "@/styles/hotel-with-price-and-term-slide";
import moment from "moment";
import Image from "next/image";
const Row = t0 => {
  const $ = _c(56);
  const {
    orientation,
    row
  } = t0;
  let t1;
  if ($[0] !== row.departure_location_name) {
    t1 = row.departure_location_name.split(",");
    $[0] = row.departure_location_name;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const departureLocations = t1;
  let departureLocationName = "";
  if (departureLocations.length > 0) {
    departureLocationName = departureLocations[0];
  }
  if (departureLocations.length > 1) {
    departureLocationName = departureLocationName + ", " + departureLocations[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      fontWeight: "bold"
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = row.destination_color;
  const t4 = row.has_shade_destination ? row.shade_color_destination : undefined;
  let t5;
  if ($[3] !== row.category) {
    t5 = "*".repeat(row.category);
    $[3] = row.category;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== orientation || $[6] !== row.destination_color || $[7] !== row.tour_id.label || $[8] !== t4 || $[9] !== t5) {
    t6 = <DestinationRowDestination $orientation={orientation} style={t2} $color={t3} $shade={t4}>{t5} {row.tour_id.label}</DestinationRowDestination>;
    $[5] = orientation;
    $[6] = row.destination_color;
    $[7] = row.tour_id.label;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== departureLocationName || $[12] !== orientation || $[13] !== row.destination_color || $[14] !== row.has_shade_destination || $[15] !== row.location || $[16] !== row.plane_color || $[17] !== row.shade_color_destination || $[18] !== row.show_destination) {
    t7 = !row.show_destination ? <div style={{
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
      gap: "0.1rem"
    }}><PlaneDiv><Image src={`/${getPlaneImage(row.plane_color)}`} alt="plane" fill={true} /></PlaneDiv><DestinationRowDestination $orientation={orientation} $color={row.destination_color} $shade={row.has_shade_destination ? row.shade_color_destination : undefined}>{departureLocationName}</DestinationRowDestination></div> : <DestinationRowDestination $orientation={orientation} $color={row.destination_color} $shade={row.has_shade_destination ? row.shade_color_destination : undefined}>{row.location}</DestinationRowDestination>;
    $[11] = departureLocationName;
    $[12] = orientation;
    $[13] = row.destination_color;
    $[14] = row.has_shade_destination;
    $[15] = row.location;
    $[16] = row.plane_color;
    $[17] = row.shade_color_destination;
    $[18] = row.show_destination;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== t6 || $[21] !== t7) {
    t8 = <div>{t6}{t7}</div>;
    $[20] = t6;
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  const t9 = row.destination_color;
  const t10 = row.has_shade_destination ? row.shade_color_destination : undefined;
  let t11;
  if ($[23] !== row.term_start) {
    t11 = moment(row.term_start).format("D.M.");
    $[23] = row.term_start;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== orientation || $[26] !== row.destination_color || $[27] !== t10 || $[28] !== t11) {
    t12 = <DestinationRowDestination $orientation={orientation} $color={t9} $shade={t10}>{t11}</DestinationRowDestination>;
    $[25] = orientation;
    $[26] = row.destination_color;
    $[27] = t10;
    $[28] = t11;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  const t13 = row.has_shade_destination ? row.shade_color_destination : undefined;
  let t14;
  if ($[30] !== orientation || $[31] !== row.destination_color || $[32] !== row.nights || $[33] !== t13) {
    t14 = <DestinationRowDestination $orientation={orientation} $color={row.destination_color} $shade={t13}>{row.nights} nocí</DestinationRowDestination>;
    $[30] = orientation;
    $[31] = row.destination_color;
    $[32] = row.nights;
    $[33] = t13;
    $[34] = t14;
  } else {
    t14 = $[34];
  }
  const t15 = row.has_shade_destination ? row.shade_color_destination : undefined;
  let t16;
  if ($[35] !== orientation || $[36] !== row.board || $[37] !== row.destination_color || $[38] !== t15) {
    t16 = <DestinationRowDestination $orientation={orientation} $color={row.destination_color} $shade={t15}>{row.board}</DestinationRowDestination>;
    $[35] = orientation;
    $[36] = row.board;
    $[37] = row.destination_color;
    $[38] = t15;
    $[39] = t16;
  } else {
    t16 = $[39];
  }
  const t17 = row.price_color;
  const t18 = row.has_shade_price ? row.shade_price_color : undefined;
  let t19;
  if ($[40] !== row.price) {
    t19 = formatCurrency(row.price);
    $[40] = row.price;
    $[41] = t19;
  } else {
    t19 = $[41];
  }
  let t20;
  if ($[42] !== orientation || $[43] !== row.price_color || $[44] !== t18 || $[45] !== t19) {
    t20 = <DestinationRowPrice $orientation={orientation} $color={t17} $shade={t18}>{t19}</DestinationRowPrice>;
    $[42] = orientation;
    $[43] = row.price_color;
    $[44] = t18;
    $[45] = t19;
    $[46] = t20;
  } else {
    t20 = $[46];
  }
  let t21;
  if ($[47] !== t12 || $[48] !== t14 || $[49] !== t16 || $[50] !== t20) {
    t21 = <div>{t12}{t14}{t16}{t20}</div>;
    $[47] = t12;
    $[48] = t14;
    $[49] = t16;
    $[50] = t20;
    $[51] = t21;
  } else {
    t21 = $[51];
  }
  let t22;
  if ($[52] !== orientation || $[53] !== t21 || $[54] !== t8) {
    t22 = <StyledRow $orientation={orientation}>{t8}{t21}</StyledRow>;
    $[52] = orientation;
    $[53] = t21;
    $[54] = t8;
    $[55] = t22;
  } else {
    t22 = $[55];
  }
  return t22;
};
const HotelWithTermAndPriceSlide = t0 => {
  const $ = _c(27);
  const {
    slide
  } = t0;
  const t1 = slide.orientation;
  const t2 = slide.attributes.position?.value ?? "left";
  const t3 = `https://www.alexandria.cz/${slide.attributes.filePath}`;
  let t4;
  if ($[0] !== t3) {
    t4 = <Image fill={true} alt="" src={t3} priority={true} />;
    $[0] = t3;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const t5 = slide.attributes.has_shade_title_1 ? slide.attributes.shade_color_title_1 : undefined;
  let t6;
  if ($[2] !== slide.attributes.color_title_1 || $[3] !== slide.attributes.title_1 || $[4] !== slide.orientation || $[5] !== t5) {
    t6 = <StyledH1 $orientation={slide.orientation} $color={slide.attributes.color_title_1} $shade={t5}>{slide.attributes.title_1}</StyledH1>;
    $[2] = slide.attributes.color_title_1;
    $[3] = slide.attributes.title_1;
    $[4] = slide.orientation;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const t7 = slide.attributes.has_shade_title_2 ? slide.attributes.shade_color_title_2 : undefined;
  const t8 = slide.attributes.position?.value ?? "left";
  let t9;
  if ($[7] !== slide.attributes.color_title_2 || $[8] !== slide.attributes.title_2 || $[9] !== slide.orientation || $[10] !== t7 || $[11] !== t8) {
    t9 = <StyledH2 $orientation={slide.orientation} $color={slide.attributes.color_title_2} $shade={t7} $position={t8}>{slide.attributes.title_2}</StyledH2>;
    $[7] = slide.attributes.color_title_2;
    $[8] = slide.attributes.title_2;
    $[9] = slide.orientation;
    $[10] = t7;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== slide.attributes.rows || $[14] !== slide.orientation) {
    let t11;
    if ($[16] !== slide.orientation) {
      t11 = (row, index) => <Row orientation={slide.orientation} key={index} row={row} />;
      $[16] = slide.orientation;
      $[17] = t11;
    } else {
      t11 = $[17];
    }
    t10 = slide.attributes.rows.map(t11);
    $[13] = slide.attributes.rows;
    $[14] = slide.orientation;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[18] !== t10 || $[19] !== t6 || $[20] !== t9) {
    t11 = <div>{t6}{t9}{t10}</div>;
    $[18] = t10;
    $[19] = t6;
    $[20] = t9;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== slide.orientation || $[23] !== t11 || $[24] !== t2 || $[25] !== t4) {
    t12 = <StyledHotelWithPriceAndTermSlide $orientation={t1} $position={t2}>{t4}{t11}</StyledHotelWithPriceAndTermSlide>;
    $[22] = slide.orientation;
    $[23] = t11;
    $[24] = t2;
    $[25] = t4;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  return t12;
};
export default HotelWithTermAndPriceSlide;